import { Type } from '@angular/core';

import { ProminenceFilterApiModel } from '../../../../api/mentions/model/prominence-filter-api.model';
import { FilterTypesEnum } from '../../../../Common/Filter/enums/filters-types.enum';
import { AbstractFilterTypeComponent } from '../../../../Common/Filter/models/abstract-filter-type.component';
import { CustomFilterTypeModel } from '../../../../Common/Filter/models/custom-filter-type.model';
import { FilterOptionModel } from '../../../../Common/Filter/models/filter-option.model';
import { ChipModel } from '../../../../Common/Forms/models/chip.model';
import { ProminenceScoreModel } from '../../models/prominence-score.model';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';

export class CheckboxGroup {
    label: string;
    id: number;
    checkboxes: FilterOptionModel[];
}

export class ProminenceFilterModel extends CustomFilterTypeModel<ProminenceFilterApiModel> {
    readonly key: FilterTypesEnum = FilterTypesEnum.custom;
    options: CheckboxGroup[];

    value: ProminenceFilterApiModel;
    currentValue: ProminenceFilterApiModel;
    hideFacet: boolean = false;

    localizationservice: LocalizationService;

    constructor(
        id: string,
        label: string,
        component: Type<AbstractFilterTypeComponent>,
        localizationService: LocalizationService,
        section?: string,
        hideFacet?: boolean
    ) {
        super(id, label, component, section, true);
        this.localizationservice = localizationService;
        this.hideFacet = hideFacet;
    }

    private makeChips(val: ProminenceFilterApiModel): ChipModel[] {
        const chips: ChipModel[] = [];

        if (val) {
            val.filters.forEach(filter => {
                let chip: string = filter.prominenceGroup.name;
                chip += ' - ';
                const rangeString = filter.ranges
                    .map(range => this.localizationservice.transform(
                        ProminenceScoreModel.getProminenceLabel(ProminenceScoreModel.getProminenceLevel(range.max)))
                    )
                    .join(', ');

                if (filter.ranges.length > 1) {
                    chip += '[ ' + rangeString + ' ]';
                } else {
                    chip += rangeString;
                }
                chips.push({
                    label: chip,
                    labelArgs: {
                        id: filter.prominenceGroup.id
                    }
                });
            });
        }
        return chips;
    }

    setValue(value: ProminenceFilterApiModel): void {
        this.value = value;
        this.chips = this.makeChips(value);
        this.cancelChanges();
        this.updateChipSuffix();
    }

    getValue(): ProminenceFilterApiModel {
        return this.value;
    }

    removeChip(chip: ChipModel): void {
        const groupId = chip.labelArgs['id'];
        this.getValue().filters = this.getValue().filters.filter(x => x.prominenceGroup.id !== groupId);
        this.setCurrentValue(this.getValue());
        this.chips = this.makeChips(this.value);
    }

    clear(): void {
        this.setValue(null);
    }

    setCurrentValue(value: ProminenceFilterApiModel): void {
        this.currentValue = value;
        this.currentChips = this.makeChips(this.currentValue);
        this.updateCurrentChipSuffix();
    }

    getCurrentValue(): ProminenceFilterApiModel {
        return this.currentValue;
    }

    cancelChanges(): void {
        if (this.value) {
            this.setCurrentValue(JSON.parse(JSON.stringify(this.value)));
        } else {
            this.setCurrentValue(null);
        }
    }

    removeCurrentChip(chip: ChipModel): void {
        const groupId = chip.labelArgs['id'];
        this.getCurrentValue().filters = this.getCurrentValue().filters.filter(x => x.prominenceGroup.id !== groupId);
        this.currentChips = this.makeChips(this.currentValue);
    }
}
